import "core-js/modules/es6.array.map";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      Year: [],
      Column: [],
      title: "",
      Field: [],
      islingyu: false,
      islanmu: false,
      num: "",
      loading: true,
      isgzh: 0,
      Number: ""
    };
  },
  mounted: function mounted() {
    var _this = this;

    var params = [1000, 1001, 4530, 6018, 6019, 230, 6055, 5000, 5010, 99, 96, 2960, 4553, 310, 4554]; //1000:期刊名称
    //1001：期刊英文名称
    //4530：（否）隐藏/（是）显示预出版模块
    //6018:预出版模块显示 （否）文章列表/（是）预出版内容
    //6019：是否需要登录下载文件
    //230：显示/隐藏所有的评论功能
    //6055：显示/隐藏列表和详情页的英文标题，英文关键字，英文摘要
    //5000： ISSN编号
    //5010：CN编号

    this.$store.dispatch("_getSet", params).then(function (res) {
      sessionStorage.setItem("SetItem", JSON.stringify(res.data.Data));
      var SetItem = res.data.Data;
      SetItem.map(function (item) {
        if (item.SetItemID == 1000) {
          _this.title = item.Item_Value;
        }

        if (item.SetItemID == 99) {
          if (item.Item_Value == "是") {
            _this.islingyu = true;
          } else {
            _this.islingyu = false;
          }
        }

        if (item.SetItemID == 96) {
          if (item.Item_Value == "是") {
            _this.islanmu = true;
          } else {
            _this.islanmu = false;
          }
        }

        if (item.SetItemID == 4554) {
          _this.num = item.Item_Value;
        }
      });

      _this.getmenu();
    });
  },
  watch: {
    num: function num(o, l) {
      console.log(o, l);
      this.Number = l;
    }
  },
  methods: {
    getmenu: function getmenu() {
      var _this2 = this;

      this.$store.dispatch("_getgok").then(function (res) {
        if (res.data.IsSuccess) {
          _this2.loading = false;
          _this2.Year = res.data.Data.Year;

          if (_this2.islingyu == true) {
            _this2.Field = res.data.Data.Field;
          } else {
            _this2.Field = [];
          }

          if (_this2.islanmu == true) {
            _this2.Column = res.data.Data.Column;
          } else {
            _this2.Column = [];
          }
        } else {}
      }).catch(function (err) {
        console.log(err);
      });
    },
    tomouth: function tomouth(id, type) {
      this.$router.push({
        path: "/OAList?IssueId=" + id
      });
    },
    tomouthgzh: function tomouthgzh(id, type) {
      this.$router.push({
        path: "/gzhOAList?IssueId=" + id
      });
    },
    tomoutha: function tomoutha(id, type) {
      this.$router.push({
        path: "/FieldColumnList?IssueId=" + id + "&type=" + type
      });
    },
    opena: function opena() {
      if (this.$refs.openp.innerText === "展开") {
        this.$refs.len.style.height = "";
        this.$refs.openp.innerText = "收缩";
      } else {
        this.$refs.len.style.height = 80 + "px";
        this.$refs.openp.innerText = "展开";
      }
    },
    opena1: function opena1() {
      if (this.$refs.openp1.innerText === "展开") {
        this.$refs.len1.style.height = "";
        this.$refs.openp1.innerText = "收缩";
      } else {
        this.$refs.len1.style.height = 80 + "px";
        this.$refs.openp1.innerText = "展开";
      }
    },
    opena2: function opena2() {
      if (this.$refs.openp2.innerText === "展开") {
        // this.$refs.len2.style.height = ''
        this.num = this.Year.length;
        this.$refs.openp2.innerText = "收缩";
      } else {
        // this.$refs.len2.style.height = 380 + 'px'
        this.num = this.Number;
        this.$refs.openp2.innerText = "展开";
      }
    }
  }
};